import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { RobotoUserConfigKey } from "../ConfigRecords";

export function getQueryKey(key: RobotoUserConfigKey) {
  return ["userConfig", key];
}

export function useUserConfig(key: RobotoUserConfigKey) {
  const { configService } = useDomainServices();

  return useQuery({
    queryKey: getQueryKey(key),
    queryFn: ({ signal }) => {
      return configService.getUserConfig(key, {
        abortSignal: signal,
      });
    },
  });
}
